import moment from "moment";
const timeType = {
    ymd:'YYYY-MM-DD',
    ymdhms:'YYYY/MM/DD HH:mm:ss'
}
// 获取当前时间
const getCurrentTime = (date,type = timeType.ymd) => {
   return moment(date).format(type)
}
// 固定时间后
const getTimeByDay = (date,type = timeType.ymd) => {
    return moment(moment(date).subtract(7,'days')).format(type)
}
// 固定时间前
const getTime = (date,type = timeType.ymdhms) => {
    return moment(date).format(type)
}
export default {
    getCurrentTime,
    getTimeByDay,
    getTime
}